import { Component, ViewChild } from '@angular/core';
import { PurchaseManagerListingComponent } from './purchase-manager-listing/purchase-manager-listing.component';

@Component({
  selector: 'app-purchase-manager',
  templateUrl: './purchase-manager.component.html',
  styleUrls: ['./purchase-manager.component.scss']
})
export class PurchaseManagerComponent {

  @ViewChild('purchaseManagerListing') purchaseManagerListing!: PurchaseManagerListingComponent;

  onPurchaseManagerAdded(): void {
    console.log('Purchase manager added event received');
    if (this.purchaseManagerListing) {
      this.purchaseManagerListing.onPurchaseManagerAdded();
    }
  }

  onPurchaseManagerUpdated(): void {
    console.log('Purchase manager updated event received');
    if (this.purchaseManagerListing) {
      this.purchaseManagerListing.onPurchaseManagerUpdated();
    }
  }
}
